module.exports = __webpack_public_path__ + "../resources/img/Icon_Arrow_Right_Color.58d3a62f.svg";